module.exports = __webpack_public_path__ + "img/92.e93440d3.png";